import { EquipmentType } from "@/models/equipment.model";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class EquipmentListHeaderComponent extends Vue {
  @Prop() equipmentType!: EquipmentType;
  @Prop() fields!: any[];

  get isPhone(): boolean {
    return !this.$screen.md;
  }

  style(field: any): any {
    return { height: `${field.line}%` };
  }
}
